import React, { useEffect, useRef } from 'react'

import type { validatorFunc } from '@/utils/validatorProvider'
import { useValidatorContext } from '@/utils/validatorProvider'

interface ValidatorProps {
	id: string
	children: React.ReactNode
	validator?: validatorFunc
	reference: React.RefObject<any>
	onError: (errors: string[]) => void
}

function Validator(props: ValidatorProps) {
	const validator = useValidatorContext()
	const container = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (props.validator) {
			validator.register({
				id: props.id,
				validate: props.validator,
				ref: props.reference,
				container,
				setter: props.onError,
			})
		}
		return () => {
			if (props.validator) validator.unregister(props.id)
		}
	}, []) //eslint-disable-line

	return <div ref={container}>{props.children}</div>
}

export default Validator
